export default __webpack_public_path__ + "static/media/top-piston.d9ced4d7.png";